import api from "@helpers/api";
import { OwnTasksCreateType } from "@type/taskManagement/ownTasks";
import { OWN_TASKS_ENDPOINT } from "./config";

export const fetchOwnTasks = async (query: any) => {
  const res = await api.get(`${OWN_TASKS_ENDPOINT}`, {
    params: query,
  });

  return res;
};

export const fetchOwnTasksById = async (id: number | string) => {
  const res = await api.get(`${OWN_TASKS_ENDPOINT}/${id}`);

  return res;
};

export const createOwnTasks = async (data: OwnTasksCreateType) => {
  const res = await api.post(`${OWN_TASKS_ENDPOINT}`, {
    ...data,
  });

  return res;
};

export const updateOwnTasks = async (id: string | number, data: any) => {
  const res = await api.put(`${OWN_TASKS_ENDPOINT}/${id}`, {
    ...data,
  });

  return res;
};

export const deleteOwnTasks = async (id: string | number) => {
  const res = await api.delete(`${OWN_TASKS_ENDPOINT}/${id}`);

  return res;
};
